import React, { HTMLAttributes } from 'react';
import Eye16 from '@honeybook/icons/dist/icons/Eye16';
import { flexCenterAll } from '@honeybook/hbui/dist/styles/mixins';
import styled from 'styled-components';
import colors from '@honeybook/hbui/dist/styles/colors';

const PreviewEye = (props: HTMLAttributes<HTMLDivElement>) => {
    return (
        <EyeContainer {...props}>
            <EyeIcon color={colors.blue20} />
        </EyeContainer>
    );
};

export default PreviewEye;

// --------------------------- Styles --------------------------- //

export const EyeContainer = styled.div`
    border-radius: 50%;
    ${flexCenterAll}
    width: 32px;
    height: 32px;
    cursor: pointer;
    transition: inherit;
    &:hover {
        background-color: ${colors.blue20_10};
    }
`;

export const EyeIcon = styled(Eye16)`
    display: flex;
`;
